"use strict";

exports.__esModule = true;
var _ElementControls = require("./ElementControls");
Object.keys(_ElementControls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ElementControls[key]) return;
  exports[key] = _ElementControls[key];
});